import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ReceiverManufacturer } from 'src/app/modules/admin-functions/system-configuration/interfaces/receiver-manufacturer';
import { PartnerCUDto } from 'src/app/modules/admin-functions/topcon-configuration/dtos/partner-cu.dto';
import { ProgressData } from 'src/app/modules/shared/dtos/progress-data';
import { ResponseDto } from 'src/app/modules/shared/dtos/response.dto';
import { ResponseModel } from 'src/app/modules/shared/models/reponse.model';
import { ProgressIndicatingService } from 'src/app/modules/shared/services/progress-indicating.service';
import { PostContractRequestDTO } from '../../edit-contract/dto/request-dto/post-contract-request-dto';
import { ProductResponseModel } from '../models/product.model';
import { CustomerContractService } from '../services/customer-support.service';

@Component({
    selector: 'app-customer-support',
    templateUrl: './customer-support.component.html',
    styleUrls: ['./customer-support.component.scss']
})
export class CustomerSupportComponent implements OnInit {
    private progress$ = new Subject<ProgressData>();
    public recieverManufacturerResponse : ReceiverManufacturer[] = [];
    public customerSupportForm: FormGroup;
    public partnerDetails: PartnerCUDto[] = [];
    public selectedPartnerName: string = '';
    public orgId: number;
    public productCodeList : {}[];
    public isProductDataAvailable : boolean = true;
    public minScheduledActivationStartDate: Date;
    public minScheduledActivationEndDate: Date;
    public showMessage : string = '';
    public isEditable : boolean = false;
    public isError : boolean = false;
    // private timerId : any;
    public maxDate: Date;

    public constructor(
        private progressService: ProgressIndicatingService,
        private messageService: MessageService,
        private customerContractService: CustomerContractService) {
    }

    public ngOnInit(): void {
        this.getRecieverManufacturer();
        this.getPartners();

        const fiveMinutesIntoFuture = new Date();
        fiveMinutesIntoFuture.setMinutes(fiveMinutesIntoFuture.getMinutes());
        const fiveMinutesIntoFutureUtc = new Date(fiveMinutesIntoFuture.getTime() + fiveMinutesIntoFuture.getTimezoneOffset() * 60 * 1000);
        this.minScheduledActivationStartDate = fiveMinutesIntoFutureUtc;

        fiveMinutesIntoFuture.setDate(this.minScheduledActivationStartDate.getDate() + 1);
        const fiveMinutesIntoFutureUtcDate = new Date(fiveMinutesIntoFuture.getTime() + fiveMinutesIntoFuture.getTimezoneOffset() * 60 * 1000);
        this.minScheduledActivationEndDate = fiveMinutesIntoFutureUtcDate;

        this.customerSupportForm = new FormGroup({
            pac: new FormControl('', [
                Validators.required,
                Validators.pattern(/^[a-zA-Z0-9]+$/),
                Validators.minLength(12),
                Validators.maxLength(13)
            ]),
            productCode: new FormControl('', [
                Validators.required,
                Validators.pattern(/^\d{4}(-\d{2}-\d{1})$/)
            ]),
            partnerId: new FormControl('', [
                Validators.required
            ]),
            receiverManufacturer: new FormControl('', [Validators.required]),
            isImmediateActivation: new FormControl(true, [
                Validators.required
            ]),
            isScheduledActivation: new FormControl(false),
            startDate: new FormControl({ value: this.minScheduledActivationStartDate, disabled: true }, [
                Validators.required
            ]),
            endDate: new FormControl('', [
                Validators.required
            ])
        });
        this.customerSupportForm.controls.productCode.disable();
        // const currentDate = new Date();
        // const utc = new Date(currentDate.getTime() + currentDate.getTimezoneOffset() * 60000);
        // this.timerId = setInterval(() => {
        //     debugger;
        //     if (this.customerSupportForm.value.startDate !== undefined) {
        //         if (utc.getMinutes() !== this.customerSupportForm.value.startDate?.getMinutes()) {
        //             this.customerSupportForm.patchValue({
        //                 startDate: utc
        //             });
        //         }
        //     }
        // }, 1000);
    }

    // public ngOnDestroy(): void {
    //     if (this.timerId) {
    //         clearInterval(this.timerId);
    //     }
    // }

    public getPartners() : void {
        this.progressService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Loading Partner Details',
                details: 'Please wait...',
                done: false
            }
        });
        this.customerContractService.getPartners().pipe(
            filter(response => new ResponseModel(response).successful),
            map(res => res.partnerCUModel)
        ).subscribe(data => {
            this.partnerDetails = data;
            this.sendProgressDoneSignal();
        },
        (response: unknown): void => {
            this.sendProgressDoneSignal();
            const res = response as { error: ResponseDto };
            this.messageService.add({ severity: 'error', summary: 'Fail', detail: new ResponseModel(res.error).message });
        });
    }

    public onChangeProductCode(event : {value : { name : {}}}) : void {
        if (event.value.name !== undefined) {
            this.customerSupportForm.get('productCode')?.clearValidators();
            this.customerSupportForm.get('productCode')?.updateValueAndValidity();
            this.isError = false;
        } else {
            this.customerSupportForm.get('productCode')?.setValidators([Validators.pattern(/^\d{4}(-\d{2}-\d{1})$/)]);
            this.customerSupportForm.get('productCode')?.updateValueAndValidity();
            this.isError = true;
        }
    }

    public getRecieverManufacturer(): void {
        this.progressService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Loading Manufacturer Details',
                details: 'Please wait...',
                done: false
            }
        });
        this.customerContractService.getSystemConfigInfo().pipe(
            filter(response => new ResponseModel(response).successful),
            map(res => res.configurations)
        ).subscribe(data => {
            this.recieverManufacturerResponse = data?.receiverManufacturers!;
            this.sendProgressDoneSignal();
        },
        (response: unknown): void => {
            this.sendProgressDoneSignal();
            const res = response as { error: ResponseDto };
            this.messageService.add({ severity: 'error', summary: 'Fail', detail: new ResponseModel(res.error).message });
        });
    }

    /* onchange partnerId bind partner name */
    public onChangePartnerId(event: { value: { organizationDisplayName: string, organizationId: number} }): void {
        this.customerSupportForm.patchValue({
            productCode: ''
        });
        if (event.value.organizationDisplayName !== '' || event.value.organizationDisplayName !== undefined) {
            this.customerSupportForm.controls.productCode.enable();
            this.selectedPartnerName = event.value.organizationDisplayName;
            this.orgId = event.value.organizationId;
            this.getPartnerByOrgId();
        }
    }

    public getPartnerByOrgId(): void {
        this.isProductDataAvailable = false;
        this.progressService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Loading Product Details',
                details: 'Please wait...',
                done: false
            }
        });
        this.productCodeList = [];
        this.customerContractService.getProductByOrgId(this.orgId).pipe(
            map(response => new ProductResponseModel(response)))
            .subscribe((response : ProductResponseModel) => {
                if (response._product !== undefined) {
                    this.isProductDataAvailable = true;
                    this.productCodeList = response?.productCode!;
                }
                this.sendProgressDoneSignal();
            },
            (response: unknown): void => {
                this.sendProgressDoneSignal();
                const res = response as { error: ResponseDto };
                this.messageService.add({ severity: 'error', summary: 'Fail', detail: new ResponseModel(res.error).message });
            });
    }

    public onImmediateActivation() : void {
        const fiveMinutesIntoFuture = new Date();
        fiveMinutesIntoFuture.setMinutes(fiveMinutesIntoFuture.getMinutes());
        const fiveMinutesIntoFutureUtc = new Date(fiveMinutesIntoFuture.getTime() + fiveMinutesIntoFuture.getTimezoneOffset() * 60 * 1000);
        this.minScheduledActivationStartDate = fiveMinutesIntoFutureUtc;

        this.customerSupportForm.controls.startDate.disable();
        this.customerSupportForm.patchValue({
            startDate: this.minScheduledActivationStartDate,
            endDate: ''
        });

        fiveMinutesIntoFuture.setDate(fiveMinutesIntoFuture.getDate() + 1);
        this.minScheduledActivationEndDate = fiveMinutesIntoFuture;
    }

    public onTodayClick() : void {
        this.customerSupportForm.patchValue({
            startDate: this.minScheduledActivationStartDate
        });
    }

    public onScheduledActivation(): void {
        this.customerSupportForm.controls.startDate.enable();
        const currentDate = new Date();
        currentDate.setMinutes(currentDate.getMinutes());
        currentDate.setDate(currentDate.getDate() + 90);
        const fiveMinutesIntoFutureUtc = new Date(currentDate.getTime() + currentDate.getTimezoneOffset() * 60 * 1000);
        // const currentDate = new Date();
        // currentDate.setMinutes(currentDate.getMinutes());
        // currentDate.setFullYear(currentDate.getFullYear());
        // currentDate.setDate(currentDate.getDate() + 90);
        this.maxDate = fiveMinutesIntoFutureUtc;
    }

    public validateStartDate(event : Date) : void {
        const tempDate = JSON.parse(JSON.stringify(event));
        const fiveMinutesIntoFuture = new Date(tempDate);
        fiveMinutesIntoFuture.setMinutes(fiveMinutesIntoFuture.getMinutes());
        fiveMinutesIntoFuture.setDate(fiveMinutesIntoFuture.getDate() + 1);
        this.minScheduledActivationEndDate = fiveMinutesIntoFuture;
        this.showMessage = '';
        if (this.customerSupportForm.value.endDate !== '' && this.customerSupportForm.value.endDate !== null) {
            if (event > this.customerSupportForm.value.endDate) {
                this.showMessage = 'Start Date should not be greater than End Date';
            } else if (event.getDate() === this.customerSupportForm.value.endDate.getDate() &&
                        event.getMonth() === this.customerSupportForm.value.endDate.getMonth() &&
                        event.getFullYear() === this.customerSupportForm.value.endDate.getFullYear()) {
                this.showMessage = 'Start Date should not be equal to End Date';
            }
        }
    }

    public validateEndDate(event : Date) : void {
        // const currentDate = new Date();
        // currentDate.setMinutes(currentDate.getMinutes());
        // currentDate.setDate(currentDate.getDate() + 1);
        // currentDate.setFullYear(currentDate.getFullYear());
        // currentDate.setMonth(currentDate.getMonth());
        // this.customerSupportForm.value.endDate = currentDate;
        this.showMessage = '';
        if (this.customerSupportForm.value.startDate !== '') {
            if (event < this.customerSupportForm.value.startDate) {
                this.showMessage = 'End Date should not be less than Start date';
            } else if ((event.getDate() === this.customerSupportForm.value.startDate?.getDate()) &&
                       (event.getMonth() === this.customerSupportForm.value.startDate?.getMonth()) &&
                       (event.getFullYear() === this.customerSupportForm.value.startDate?.getFullYear())) {
                this.showMessage = 'End Date should not be equal to Start Date';
            } else {
                this.showMessage = '';
            }
        }
    }

    public saveCustomerDetails() : void {
        this.progressService.show({
            progress$: this.progress$,
            initial: {
                done: false,
                header: 'Saving Contract Details',
                details: 'Please wait...'
            }
        });

        let startDate;
        let endDate;
        const currentDate = new Date();
        currentDate.setMinutes(currentDate.getMinutes());
        const currentDateUTC = new Date(currentDate.getTime() + currentDate.getTimezoneOffset() * 60 * 1000);

        const addFiveMin = new Date();
        addFiveMin.setMinutes(addFiveMin.getMinutes() + 5);
        const addFiveMinUTC = new Date(addFiveMin.getTime() + addFiveMin.getTimezoneOffset() * 60 * 1000);

        const substractFiveMin = new Date();
        substractFiveMin.setMinutes(substractFiveMin.getMinutes() - 5);
        const substractFiveMinUTC = new Date(substractFiveMin.getTime() + substractFiveMin.getTimezoneOffset() * 60 * 1000);
        startDate = this.customerSupportForm.value.startDate;
        if (this.customerSupportForm.value.startDate !== undefined) {
            // if ((formatDate(this.customerSupportForm.value?.startDate, 'dd:HH:mm', 'en-Us') >= formatDate(currentDateUTC, 'dd:HH:mm', 'en-Us') && formatDate(this.customerSupportForm.value?.startDate, 'dd:HH:mm', 'en-Us') < formatDate(addFiveMinUTC, 'dd:HH:mm', 'en-Us')) ||
            //     (formatDate(this.customerSupportForm.value?.startDate, 'dd:HH:mm', 'en-Us') < formatDate(currentDateUTC, 'dd:HH:mm', 'en-Us') && formatDate(this.customerSupportForm.value?.startDate, 'dd:HH:mm', 'en-Us') > formatDate(substractFiveMinUTC, 'dd:HH:mm', 'en-Us'))) {
            //     startDate.setMinutes(startDate.getMinutes() + 5);
            // } else if (formatDate(this.customerSupportForm.value?.startDate, 'dd:HH:mm', 'en-Us') <= formatDate(substractFiveMinUTC, 'dd:HH:mm', 'en-Us')) {
            //     startDate.setMinutes(currentDateUTC.getMinutes() + 5);
            // }
            if (this.customerSupportForm.value?.startDate <= currentDateUTC && this.customerSupportForm.value?.startDate > substractFiveMinUTC) {
                startDate.setMinutes(startDate.getMinutes() + 5);
            } else if (this.customerSupportForm.value?.startDate > currentDateUTC && this.customerSupportForm.value?.startDate < addFiveMinUTC) {
                startDate.setMinutes(startDate.getMinutes() + 5);
            } else if (this.customerSupportForm.value?.startDate <= substractFiveMinUTC) {
                startDate.setMinutes(currentDateUTC.getMinutes() + 5);
            }
            endDate = this.customerSupportForm.value.endDate;
            endDate.setHours(startDate.getHours());
            endDate.setMinutes(startDate.getMinutes());
            endDate.setSeconds(startDate.getSeconds());
        } else {
            startDate = new Date(this.minScheduledActivationStartDate);
            startDate.setMinutes(startDate.getMinutes());
            endDate = new Date(this.customerSupportForm.value.endDate);
            endDate.setHours(startDate.getHours());
            endDate.setMinutes(startDate.getMinutes());
            endDate.setSeconds(startDate.getSeconds());
        }
        const input : PostContractRequestDTO = {
            requestData: {
                productCode: this.customerSupportForm.value.productCode,
                manufacturer: this.customerSupportForm.value.receiverManufacturer.manufacturerName,
                pac: this.customerSupportForm.value.pac,
                partnerId: this.customerSupportForm.value.partnerId.partnerId,
                contractEndDate: formatDate(endDate, 'YYYY-MM-ddTHH:mm:ss', 'en-Us'),
                ...(!this.customerSupportForm.get('isImmediateActivation')?.value && { activationStartDate: formatDate(startDate, 'YYYY-MM-ddTHH:mm:ss', 'en-Us') }),
                organizationDisplayName: this.selectedPartnerName
            }
        };
        this.customerContractService.postContractDetails(input).subscribe(
            (response) => {
                this.apiResponsePopup(response.responseMessage!, response.responseCode!);
                this.sendProgressDoneSignal();
                if (response.responseCode === 0) {
                    const currentDate = new Date();
                    currentDate.setMinutes(currentDate.getMinutes());
                    const currentDateUTC = new Date(currentDate.getTime() + currentDate.getTimezoneOffset() * 60 * 1000);
                    this.customerSupportForm.patchValue({
                        startDate: currentDateUTC,
                        isImmediateActivation: true
                    });
                    this.customerSupportForm.controls.startDate.disable();
                }
            },
            error => {
                this.apiResponsePopup(error.error.responseMessage!, error.responseCode!);
                this.sendProgressDoneSignal();
            }
        );
    }

    private apiResponsePopup(responseMsg: string, responseCode: number) :void {
        if (responseCode === 0) {
            this.customerSupportForm.reset();
            this.messageService.add({ severity: 'success', summary: 'Success', detail: responseMsg });
        } else {
            // this.customerSupportForm.reset();
            const currentDate = new Date();
            currentDate.setMinutes(currentDate.getMinutes());
            const currentDateUTC = new Date(currentDate.getTime() + currentDate.getTimezoneOffset() * 60 * 1000);
            this.customerSupportForm.patchValue({
                startDate: currentDateUTC,
                isImmediateActivation: true
            });
            this.customerSupportForm.controls.startDate.disable();
            this.messageService.add({ severity: 'error', summary: 'Fail', detail: responseMsg });
        }
    }

    private sendProgressDoneSignal(): void {
        this.progress$.next({
            header: '',
            done: true
        });
    }
}
